<span mat-dialog-title class="title-medium on-surface-text">
  Leave {{ $pueblo().name }} Pueblo?
</span>

<span mat-dialog-content class="title-medium on-surface-text">
  You will need to request to rejoin this Pueblo.
</span>

<div mat-dialog-actions class="align-between">
  <button mat-dialog-close mat-button [disabled]="$pending()">
    Never mind
  </button>
  <button
    mat-flat-button
    class="error-button"
    (click)="handleLeave()"
    [disabled]="$pending()"
    [style.width.px]="105"
  >
    @if ($pending()) {
      <mat-spinner [diameter]="14"></mat-spinner>
    } @else {
      Leave
    }
  </button>
</div>
